import * as THREE from "three";


const addOutline = (model) => {
    var helper = new THREE.BoxHelper(model, 0x00ff00);
    helper.update();
    return helper;
}


export default addOutline;
